import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, FormGroup } from "@angular/forms";
import { Router, NavigationEnd } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { NodeService } from '../../../shared/services/nodeservice.service';
import { SupportingDocuments } from '../../../shared/services/supporting-documents';
import { Note } from '../../../shared/services/note';
import { AuditHistory } from '../../../shared/services/audit-history';

@Component({
    selector: 'app-redemptions-application-details',
    templateUrl: './redemptions-application-details.component.html'
})
export class RedemptionApplicationDetailsComponent implements OnInit {

    loading: boolean;
    files2: SupportingDocuments[];
    files3: Note[];
    files4: AuditHistory[];

    cols: any[];
    contactDetailsForm: FormGroup;
    uploadForm: FormGroup;
    notesForm: FormGroup;

    showEmailApplicantDialog: boolean = false;
    isNotSent: boolean = true;
    isSent: boolean = false;

    uploadedFiles: any[] = [];

    constructor(private title: Title, private router: Router, private nodeService: NodeService, private fb: FormBuilder) {
        this.title.setTitle('Redemptions - Redemption Details | XYZ Corp.');
    }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });

        this.loading = true;
        this.nodeService.getSupportingDocuments().then(files => this.files2 = files);
        this.nodeService.getNotes().then(files => this.files3 = files);
        this.nodeService.getAuditHistory().then(files => this.files4 = files);

        this.contactDetailsForm = this.fb.group({
            'textboxEmailAddress': new FormControl({ value: 'jcitizen@thereachagency.com', disabled: true }),
            'textboxTelephoneNumber': new FormControl({ value: '0400 000 000', disabled: true })
        });

        this.uploadForm = this.fb.group({
            'dropdownFileType': new FormControl(null),
        });

        this.notesForm = this.fb.group({
            'textareaNoteText': new FormControl(''),
        });
    }

    onNavigateBack() {
        this.router.navigate(['redemptions/requests']);
    }

    onUpload(event) {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
        }
    }

}
